/**
 * Thinking Engine — memory-aware genome resolution.
 *
 * Picks the final Style Genome the reasoning will run on: the preferred genome
 * unless memory flags it as over-used, in which case it switches to the first
 * distinct research-recommended genome. Switching the genome cascades a
 * coherent change through every downstream decision (a senior designer varies
 * by choosing a different visual language, not by randomly nudging one axis).
 * Deterministic.
 */

import { getGenome } from '../genome';

/**
 * @param {(string|Object|null)} given  preferred genome id or object.
 * @param {Object} research             Research Brief (recommendedGenomes).
 * @param {Object} constraints          Memory constraints (avoid.genome).
 * @returns {{ genome: Object, swapped: boolean, from: (string|null), avoided: (string|null) }}
 */
export const resolveGenome = (given, research = {}, constraints = {}) => {
  const givenId = typeof given === 'string' ? given : (given && given.id) || null;
  const avoided = (constraints.generationConstraints && constraints.generationConstraints.avoid && constraints.generationConstraints.avoid.genome) || null;
  const recommended = Array.isArray(research.recommendedGenomes) ? research.recommendedGenomes : [];
  const candidates = [givenId, ...recommended, 'modern', 'minimal'].filter(Boolean);

  let chosen = null;
  for (const id of candidates) {
    const g = getGenome(id);
    if (g && id !== avoided) { chosen = g; break; }
  }
  if (!chosen) { // everything was avoided or unresolved — take the first resolvable
    for (const id of candidates) { const g = getGenome(id); if (g) { chosen = g; break; } }
  }
  if (!chosen) chosen = getGenome('modern');

  return { genome: chosen, swapped: Boolean(givenId && chosen.id !== givenId), from: givenId, avoided };
};
